import {
  applyPermissionGroupsToUser,
  normalizePermissionGroupIds,
} from "../../utilis/permissionGroupMembership";
import {
  assignUserPermissionGroup,
  fetchPermissionGroups,
} from "./permissionGroupsApi";

/**
 * Sync a user's role memberships to match target role ids (primary + additional).
 */
export async function syncUserRoleMembership(userId, targetRoleIds, previousRoleIds) {
  const target = new Set(
    (targetRoleIds || []).map((id) => Number(id)).filter((id) => id > 0),
  );
  const previous = new Set(
    (previousRoleIds || []).map((id) => Number(id)).filter((id) => id > 0),
  );

  let lastPayload = null;
  for (const id of previous) {
    if (!target.has(id)) {
      lastPayload = await assignUserPermissionGroup(userId, id, false);
    }
  }
  for (const id of target) {
    if (!previous.has(id)) {
      lastPayload = await assignUserPermissionGroup(userId, id, true);
    }
  }
  return lastPayload;
}

export function splitPrimaryAndAdditionalRoleIds(allIds, primaryRoleId) {
  const ids = normalizePermissionGroupIds({ permission_group_ids: allIds });
  const primary = Number(primaryRoleId);
  if (!primary || primary <= 0) {
    return { primaryRoleId: ids[0] ?? null, additionalRoleIds: ids.slice(1) };
  }
  const additional = ids.filter((id) => id !== primary);
  return { primaryRoleId: primary, additionalRoleIds: additional };
}

export function buildTargetRoleIds(primaryRoleId, additionalRoleIds) {
  const primary = Number(primaryRoleId);
  const extras = (additionalRoleIds || [])
    .map((id) => Number(id))
    .filter((id) => id > 0 && id !== primary);
  if (!primary || primary <= 0) return extras;
  return [primary, ...extras];
}

export { applyPermissionGroupsToUser, normalizePermissionGroupIds, fetchPermissionGroups };
